import { useRef } from "react"
import { PartenerList } from "../../components/Contents/partenerpage/PartenerList"
import { Footer } from "../../components/footers/Footer"
import { HomeHeader } from "../../components/headers/HomeHeader"
import { PartenerHero } from "../../components/heros/PartenerHero"
import { PageMain } from "../../components/seo/PageMain"
import { PageSeoHelmet } from "../../components/seo/PageSeoHelmet"
import { STATIC_PAGE_SEO_META } from "../../components/seo/staticPageSeoMeta"
import gsap, {} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import TextPlugin from "gsap/TextPlugin";
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP, ScrollTrigger, TextPlugin);
export const Parteners = () => {
  const partnerRes = useRef();

  useGSAP(() => {
    const partnerHead = gsap.utils.toArray('.partner-header');
    const partnerInputs = gsap.utils.toArray('.partner-inputs');
    const partnersSubTitle = gsap.utils.toArray('.partners-subTitle');
    const partnersTitle = gsap.utils.toArray('.partners-title');
    const partnerTimeline = gsap.timeline();
    partnerTimeline.fromTo(partnerHead[0], {clipPath: 'inset(0% 0% 100% 0%)'}, {clipPath: 'inset(0% 0% 0% 0%)', duration: 1});
    partnerTimeline.fromTo(partnerInputs[0], {clipPath: 'inset(100% 0% 0% 0%)'}, {clipPath: 'inset(0% 0% 0% 0%)', duration: 0.5}, "+=0");
    partnerTimeline.fromTo(partnersSubTitle[0], {y: '100%', opacity: 0}, {y: '0', opacity: 1, ease: 'power1.out', duration: 0.7}, "+=0");
    partnerTimeline.fromTo(partnersTitle[0], {y: '100%', opacity: 0}, {y: '0', opacity: 1, ease: 'power1.out', duration: 0.9}, "+=0");
  }, {scope: partnerRes})

  return (
    <>
      <PageSeoHelmet {...STATIC_PAGE_SEO_META.partners} />
      <div className="w-full overflow-x-hidden">
        <HomeHeader headerColor={'#0D131E'} textColor={'#ffffff'} />
        <PageMain ref={partnerRes} className="parteners-page ">
          <PartenerHero />
          <PartenerList />
        </PageMain>
        <Footer />
      </div>
    </>
  );
}